import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectOfferId = createSelector(selectJsonQuery, jsonQuery => getTermValue('id')(jsonQuery));
